<template>
  <section class="card mt-3 mb-2">
    <div class="card-header card-header-light d-flex justify-content-between">
      <h4 class="card-header__title">{{ $t('src/components/training/trainingmanage.4393') }}</h4>

      <div class="card-header__month-pagination d-flex flex-row">
        <div class="dropdown-container">
          <div v-if="isCanSwitchPeriod">
            <button
              type="button"
              class="btn btn-vertical btn-with-icon"
              @click="prevPeriod"
              :disabled="false"
            >
              <svg-icon
                class="svg-icon right-turn"
                :name="'arrow-right'"
                :isDisabled="false"
                :width="15"
                :height="15"
              ></svg-icon>
            </button>
            <button
              type="button"
              class="btn btn-vertical btn-with-icon"
              @click="nextPeriod"
              :disabled="!isCanScrollNext"
            >
              <svg-icon
                class="svg-icon"
                :name="'arrow-right'"
                :IsDisabled="!isCanScrollNext"
                :width="15"
                :height="15"
              ></svg-icon>
            </button>
          </div>
          <base-dropdown-select
            :options="listOfMeasurementTypes"
            v-model="selectedMeasurementType"
            class="form-control min-size min-width ml-2"
          ></base-dropdown-select>

          <base-dropdown-select
            :options="listOfTimeData"
            v-model="timeData"
            class="form-control min-size ml-2"
            style="min-width: 120px;"
          ></base-dropdown-select>
        </div>

        <base-calendar-wrap v-if="isCanSwitchPeriod" :is-small="true" class="ml-2" style="width: auto;">
          <date-input
            :value="selectedDate"
            @input="changeSelectedDate"
            :max-date="nowFormatServer"
          ></date-input>
        </base-calendar-wrap>

        <div class="mr-3 ml-3" style="border-left: 1px solid #D9D9DD;"></div>

        <div class="btn-group">
          <button
            type="button"
            class="btn btn-outline-none btn-with-icon"
            :class="reportView === 'line' ? 'btn-secondary-light' : 'btn-outline-secondary'"
            @click="setViewReport('line')"
            :title="$t('src/components/training/trainingmanage.1')"
          >
            <svg-icon :name="'menu_burger'"></svg-icon>
          </button>
          <button
            type="button"
            class="btn btn-outline-none btn-with-icon"
            :class="reportView === 'graph' ? 'btn-secondary-light' : 'btn-outline-secondary'"
            @click="setViewReport('graph')"
            :title="$t('src/components/training/trainingmanage.3')"
          >
            <svg-icon :name="'graph'"></svg-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <course-data-table
        v-show="this.reportView === 'line'"
        :trainings="standardTrainings"
        :trainings6mwt="wt6mTrainings"
        :isStandart="trainingsForReport"
        :allDoneTrainings="doneTrainings"
        :freeMeasurementsData="freeMeasurementsData"
        :activeMeasurementType="+selectedMeasurementType"
        :activeTimeData="+timeData"
        :selectedDate="selectedDate"
        @select:date="selectDate"
      ></course-data-table>
      <course-report-graph
        v-show="this.reportView === 'graph'"
        ref="graph"
        :trainings="standardTrainings"
        :trainings6mwt="wt6mTrainings"
        :allDoneTrainings="doneTrainings"
        :freeMeasurementsData="freeMeasurementsData"
        :activeMeasurementType="+selectedMeasurementType"
        :activeTimeData="+timeData"
        :selectedDate="selectedDate"
        @selected:legend="selectedLegend"
        @select:date="selectDate"
      >
      </course-report-graph>
    </div>
  </section>
</template>

<script>
import http from '@/modules/http.js'
import { stringify } from 'qs'
import { nowMoment } from '@/mixins/now-moment'
import { legendType, timePeriods, messageTypes, measurementType, courseTypes } from '@/main.config'

export default {
  name: 'PatientDinamics',
  components: {
    SvgIcon: () => import('@/components/SvgIcon.vue'),
    CourseDataTable: () => import('@/components/CourseDataTable.vue'),
    CourseReportGraph: () => import('@/components/CourseReportGraph'),
    BaseDropdownSelect: () => import('@/base/BaseDropdownSelect.vue'),
    DateInput: () => import('@/plugins/DateInput.vue'),
    BaseCalendarWrap: () => import('@/base/BaseCalendarWrap')
  },
  mixins: [nowMoment],
  props: {
    course: {
      type: Object,
      required: true
    },
    doneTrainings: {
      type: Array,
      required: true
    },
    trainingsInfo: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      isOnly6mwt: false,
      reportView: null,
      generalListOfMeasurementTypes: {
        [measurementType.all]: this.$t('courseReport.allMeasurement'),
        [measurementType.standart]:
          this.course.course_type === courseTypes.rehab
            ? this.$t('entity.trainings')
            : this.$t('entity.sessions'),
        [measurementType.mwt6]: this.$t('src/pages/trainingview.wt6m'),
        [measurementType.free]: this.$t('courseReport.freeMeasurements')
      },
      /** Перечисление допустимых видов измерения для каждого вида графика */
      acceptableMeasurementTypes: [
        {
          legendType: legendType.holdHR,
          measurements: [measurementType.standart, measurementType.mwt6]
        },
        {
          legendType: legendType.averageHR,
          measurements: [measurementType.all, measurementType.standart, measurementType.mwt6]
        },
        {
          legendType: legendType.distance,
          measurements: [measurementType.standart, measurementType.mwt6]
        },
        {
          legendType: legendType.saturation,
          measurements: [measurementType.all, measurementType.standart, measurementType.mwt6, measurementType.free]
        },
        {
          legendType: legendType.pressure,
          measurements: [measurementType.all, measurementType.standart, measurementType.mwt6, measurementType.free]
        },
        {
          legendType: legendType.glucose,
          measurements: [measurementType.free]
        }
      ],
      selectedMeasurementType: measurementType.all,
      listOfTimeData: {
        1: this.$t('courseReport.allTime'),
        2: this.$t('courseReport.oneDay'),
        3: this.$t('courseReport.oneWeek'),
        4: this.$t('courseReport.oneMonth'),
        5: this.$t('courseReport.threeMonth')
      },
      timeData: 1,
      freeMeasurementsData: null,
      legendSelectType: 0,
      selectedDate: null
    }
  },
  computed: {
    wt6mTrainings() {
      return this.doneTrainings.filter(training => training.training_type === 1)
    },
    standardTrainings() {
      return this.doneTrainings.filter(training => training.training_type === 0)
    },
    trainingsForReport() {
      if (this.isOnly6mwt) {
        return false
      } else return true
    },
    listOfMeasurementTypes() {
      let opt = {}
      let measurementTypesKeys = []
      if (this.reportView === 'line') 
        measurementTypesKeys = Object.keys(this.generalListOfMeasurementTypes)
      else
        measurementTypesKeys = this.acceptableMeasurementTypes.find(
            item => item.legendType === this.legendSelectType
          ).measurements

      measurementTypesKeys.forEach(key => {
          opt[key] = this.generalListOfMeasurementTypes[key]
        })
      return opt
    },
    isCanSwitchPeriod() {
      return [timePeriods.oneDay, timePeriods.oneWeek].includes(+this.timeData)
    },
    isCanScrollNext() {
      const currentDate = new Date()
      const selectedDate = this.selectedDate
      if (selectedDate.getTime() < currentDate.getTime()) {
        return true
      } else return false
    }
  },
  created() {
    const currentDate = new Date()
    this.selectedDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())
    this.setStorageReportView()
    this.loadDataMeasurements().then(data => {
      this.freeMeasurementsData = data.data.map(item => {
        item.date_start = item.createdAt
        return item
      })
    })
  },
  methods: {
    openEdit() {
      this.isOnly6mwt = !this.isOnly6mwt
    },
    setStorageReportView() {
      this.reportView = 'graph'
    },
    setViewReport(view) {
      this.reportView = view
    },
    loadDataMeasurements() {
      return new Promise(resolve => {
        http
          .get('/messages', {
            params: {
              course_id: this.course.id,
              type: { $in: [messageTypes.saturation, messageTypes.pressure, messageTypes.glucose] },
              $limit: 1000 //TODO
            },
            paramsSerializer: params =>
              stringify(params, {
                arrayFormat: 'indices',
                encodeValuesOnly: true
              })
          })
          .then(response => response.data)
          .then(data => {
            resolve(data)
          })
          .catch(error => console.error(error))
      })
    },
    selectedLegend(indexLegend) {
      this.legendSelectType = indexLegend
      this.resetSelectedMeasurementType()
    },
    selectDate(date) {
      this.selectedDate = date
    },
    changeSelectedDate(date) {
      const parts = date.split('-')
      const year = parseInt(parts[0], 10)
      const month = parseInt(parts[1], 10) - 1
      const day = parseInt(parts[2], 10)
      const dateObject = new Date(year, month, day)
      this.selectedDate = dateObject
    },
    nextPeriod() {
      let numberOfDay = this.getNumberOfDayByTimeDate()
      let newSelectedDate = this.changeSelectedDateByArrow(numberOfDay)
      let currentDate = new Date()
      currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())
      this.selectedDate = newSelectedDate.getDate() > currentDate.getDate() ? currentDate : newSelectedDate
    },
    prevPeriod() {
      let numberOfDay = this.getNumberOfDayByTimeDate()
      this.selectedDate = this.changeSelectedDateByArrow(-numberOfDay)
    },
    changeSelectedDateByArrow(numberOfDay) {
      return new Date(
        this.selectedDate.getFullYear(),
        this.selectedDate.getMonth(),
        this.selectedDate.getDate() + numberOfDay
      )
    },
    getNumberOfDayByTimeDate() {
      switch (+this.timeData) {
        case timePeriods.oneDay:
          return 1
        case timePeriods.oneWeek:
          return 7
        case timePeriods.oneMonth:
          return 30
      }
    },
    resetSelectedMeasurementType() {
      const currentMeasurementTypes = this.listOfMeasurementTypes
      if (Object.keys(currentMeasurementTypes).includes(measurementType.all.toString())) {
        this.selectedMeasurementType = measurementType.all
      }
      else if (Object.keys(currentMeasurementTypes).includes(measurementType.standart.toString())) {
        this.selectedMeasurementType = measurementType.standart
      } else {
        this.selectedMeasurementType = measurementType.free
      }
    },
  }
}
</script>
